var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.22,
    height: 30.347,
    viewBox: "0 0 26.22 30.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M139.594,45.62a5.854,5.854,0,0,0-4.814,2.172,4.478,4.478,0,0,0-.646,1.183c-.234.617-.089.9.534,1.084a8.984,8.984,0,0,0,1.4.294,3.9,3.9,0,0,1,2.881,1.528c.138.194.324.352.48.534a2.79,2.79,0,0,0,2.772.894,3.158,3.158,0,0,0,2.287-1.934,1.178,1.178,0,0,0,.083-.181,3.842,3.842,0,0,0-.25-2.748c-.075-.137-.137-.273-.219-.395a5.07,5.07,0,0,0-4.424-2.431H139.6Z",
    transform: "translate(-134.029 -45.62)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84",
    "data-name": "Trac\\xE9 84",
    d: "M217.748,129.429a16.7,16.7,0,0,0-1.167,1.288,3.731,3.731,0,0,1-2.471,1.4,7.268,7.268,0,0,0-1.429.344.494.494,0,0,0-.142.079,2.877,2.877,0,0,0-1.194,4.168,1.3,1.3,0,0,1,.1.189.945.945,0,0,0,.246.317,5.577,5.577,0,0,0,.78.653,4.864,4.864,0,0,0,5.873-1.037,4.677,4.677,0,0,0,1.2-1.98,5.411,5.411,0,0,0,.432-2.894,4.42,4.42,0,0,0-.937-2.435c-.246-.291-.447-.438-.661-.438a.988.988,0,0,0-.633.35h0Z",
    transform: "translate(-210.845 -129.08)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85",
    "data-name": "Trac\\xE9 85",
    d: "M107.04,130.436a4.435,4.435,0,0,0-1.7,1.794,5.829,5.829,0,0,0-.572,2.295,6.272,6.272,0,0,0,4.489,5.732,2.833,2.833,0,0,0,1.848.04c.463-.084.646-.252.584-.675a9.742,9.742,0,0,0-.366-1.494c0-.013-.01-.026-.015-.038-.13-.5-.259-1.049-.335-1.372a2.594,2.594,0,0,1-.064-.733,5.089,5.089,0,0,1,.358-1.245c.054-.117.112-.234.177-.353a2.3,2.3,0,0,0,.2-1.954,3.156,3.156,0,0,0-2.76-2.4,2.589,2.589,0,0,0-.322-.02,3.217,3.217,0,0,0-1.523.426h0Z",
    transform: "translate(-104.764 -130.01)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mol\\xE9cule_3D",
    "data-name": "mol\\xE9cule 3D",
    transform: "translate(-0.003 -1.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M130.08,306.55a2.919,2.919,0,0,1,2.92-.283",
    transform: "translate(-122.136 -285.431)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_29",
    "data-name": "Trac\\xE9 29",
    d: "M111.321,138.136c0-.013-.01-.026-.015-.038-.129-.5-.259-1.049-.335-1.372a2.593,2.593,0,0,1-.064-.733,5.077,5.077,0,0,1,.358-1.244q.081-.175.177-.353a2.306,2.306,0,0,0,.2-1.954,3.156,3.156,0,0,0-2.76-2.4,3.045,3.045,0,0,0-1.845.406,4.435,4.435,0,0,0-1.7,1.794,5.84,5.84,0,0,0-.572,2.295,6.273,6.273,0,0,0,4.489,5.732,2.833,2.833,0,0,0,1.848.04c.463-.084.646-.252.584-.675a9.742,9.742,0,0,0-.366-1.494",
    transform: "translate(-98.367 -120.201)",
    fill: "#23004c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M148.01,365.374s2.306.355.887,2.04-4.879.444-6.032-.089a5.386,5.386,0,0,0-3.9,0c-1.153.444-3.193-.089-3.1-1.686s.266-1.6-.443-2.75a1.942,1.942,0,0,1,.266-2.75",
    transform: "translate(-126.727 -336.269)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M299.18,9.581s1.508,1.153,1.952-1.686.709-6.653,2.661-5.766-.976,2.839-.709,4.08,2.015,3,2.839-.355c.665-2.706-1.083-2.2-1.419-1.419-.133.311-.709,1.508,1.6,5.944s-.621,3.992-.8,2.75-1.065-1.863-1.242-1.153.683,2.505.887,3.282c.222.842.266,2.129-1.242,1.863s-1.331-1.065-2.306-.621",
    transform: "translate(-280.913 0)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M135.021,326.675s.189-.942,1.036-.847.753,1.413.659,2.072-.471.753-.659.753a.883.883,0,0,1-1.062-.766,1.94,1.94,0,0,1-.036-.714Z",
    transform: "translate(-126.701 -304.047)",
    fill: "#f36c87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M111.321,138.136c0-.013-.01-.026-.015-.038-.129-.5-.259-1.049-.335-1.372a2.593,2.593,0,0,1-.064-.733,5.077,5.077,0,0,1,.358-1.244q.081-.175.177-.353a2.306,2.306,0,0,0,.2-1.954,3.156,3.156,0,0,0-2.76-2.4,3.045,3.045,0,0,0-1.845.406,4.435,4.435,0,0,0-1.7,1.794,5.84,5.84,0,0,0-.572,2.295,6.273,6.273,0,0,0,4.489,5.732,2.833,2.833,0,0,0,1.848.04c.463-.084.646-.252.584-.675a9.742,9.742,0,0,0-.366-1.494",
    transform: "translate(-98.367 -120.201)",
    fill: "#23004c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M144.331,48.447c-.075-.137-.137-.273-.219-.395a5.074,5.074,0,0,0-4.508-2.43,5.855,5.855,0,0,0-4.814,2.172,4.469,4.469,0,0,0-.646,1.183c-.234.617-.089.9.534,1.084a9,9,0,0,0,1.4.294,3.9,3.9,0,0,1,2.881,1.528c.138.194.324.352.48.534a2.79,2.79,0,0,0,2.772.894,3.156,3.156,0,0,0,2.286-1.934,1.178,1.178,0,0,0,.083-.181,3.842,3.842,0,0,0-.25-2.748",
    transform: "translate(-125.853 -40.96)",
    fill: "#23004c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M220,131.951a4.417,4.417,0,0,0-.937-2.435c-.463-.548-.77-.587-1.294-.089a16.807,16.807,0,0,0-1.167,1.288,3.728,3.728,0,0,1-2.471,1.4,7.267,7.267,0,0,0-1.429.344.5.5,0,0,0-.142.079,2.878,2.878,0,0,0-1.194,4.169,1.243,1.243,0,0,1,.1.189.946.946,0,0,0,.246.317,5.577,5.577,0,0,0,.78.653,4.863,4.863,0,0,0,5.873-1.038,4.677,4.677,0,0,0,1.2-1.98,5.412,5.412,0,0,0,.432-2.894",
    transform: "translate(-197.989 -119.319)",
    fill: "#715ec9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M311.161,252.683c-.051-.958-.1-1.917-.178-2.873a1,1,0,0,0-.106-.344.412.412,0,0,0-.55-.2.453.453,0,0,0-.045.024,3.535,3.535,0,0,0-.339.24,14.884,14.884,0,0,1-1.373,1.16c-1.128.712-1.214.869-.771,2.126.029.083.059.167.09.248q.418,1.074.838,2.148a3.976,3.976,0,0,1,.159,3.5,1.461,1.461,0,0,0-.137.579c0,.41.283.572.625.345a1.959,1.959,0,0,0,.514-.494,5.776,5.776,0,0,0,1.234-3.746c-.007-.4.013-1.038.036-1.481a11.955,11.955,0,0,0,0-1.237",
    transform: "translate(-288.774 -232.13)",
    fill: "#da1c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M206.18,391.1a4.635,4.635,0,0,0-.947-.671c-1.07-.537-2.159-1.038-3.241-1.552-.1-.047-.2-.083-.3-.121l-1.243-.59c-.471-.186-.946-.386-1.429-.563a1.888,1.888,0,0,0-2.076.375,2.18,2.18,0,0,0-.708,2.192,2.775,2.775,0,0,0,2.734,2.046c1.776.089,3.554.152,5.331.22.429.017.858.024,1.286.009a.781.781,0,0,0,.75-.483.707.707,0,0,0-.161-.861",
    transform: "translate(-184.195 -361.908)",
    fill: "#da1c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M168.256,286.188c-.422-1.4-.911-2.775-1.376-4.16a1.667,1.667,0,0,0-.107-.241.3.3,0,0,0-.461-.152,1.6,1.6,0,0,1-.582.137,5.654,5.654,0,0,1-2.7-.429c-.453-.205-.494-.177-.708.281a1.723,1.723,0,0,1-.868,1,9.712,9.712,0,0,1-1.965.128l-.108-.006c-.116.016-.274.024-.312.122a5.7,5.7,0,0,0-.279.722c-.2.858-.41,1.715-.552,2.584a8.051,8.051,0,0,0-.09,1.692c.038.766.415,1.088,1.164.973a3.03,3.03,0,0,0,1.171-.469,4.63,4.63,0,0,0,1.571-2.045,8.38,8.38,0,0,0,.917-3.549l.092-.005c.048.127.1.254.145.381.3.814.606,1.629.914,2.443a5.323,5.323,0,0,0,1.971,2.483,4.259,4.259,0,0,0,1.17.593.852.852,0,0,0,1.193-.885,5.568,5.568,0,0,0-.2-1.6",
    transform: "translate(-148.481 -262.17)",
    fill: "#715ec9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_19",
    "data-name": "Groupe 19",
    transform: "translate(8.185 4.661)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3",
    transform: "translate(8.848 3.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M281.691,98.176a1.366,1.366,0,1,1-1.366-1.366,1.366,1.366,0,0,1,1.366,1.366h0",
    transform: "translate(-278.96 -96.81)",
    fill: "#f36c87"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_20",
    "data-name": "Groupe 20",
    transform: "translate(12.874 9.76)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    transform: "translate(6.89 4.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M326.431,204.636a1.366,1.366,0,1,1-1.366-1.366,1.366,1.366,0,0,1,1.366,1.366h0",
    transform: "translate(-323.7 -203.27)",
    fill: "#f36c87"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21",
    "data-name": "Groupe 21",
    transform: "translate(6.398 9.817)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9",
    transform: "translate(0.556 -0.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_30",
    "data-name": "Trac\\xE9 30",
    d: "M116.611,125.946a1.366,1.366,0,1,1-1.366-1.366,1.366,1.366,0,0,1,1.366,1.366h0",
    transform: "translate(-113.88 -124.58)",
    fill: "#f36c87"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M213.914,182.342a.682.682,0,1,1-.682-.682h0a.682.682,0,0,1,.682.682h0",
    transform: "translate(-199.572 -168.69)",
    fill: "#f36c87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M213.914,182.342a.682.682,0,1,1-.682-.682h0a.682.682,0,0,1,.682.682Z",
    transform: "translate(-199.572 -168.69)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M203.944,243.432a.682.682,0,1,1-.682-.682h0a.682.682,0,0,1,.682.682",
    transform: "translate(-190.21 -226.05)",
    fill: "#f36c87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M203.944,243.432a.682.682,0,1,1-.682-.682h0A.682.682,0,0,1,203.944,243.432Z",
    transform: "translate(-190.21 -226.05)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M190.933,289.611a.682.682,0,1,1-.682-.681h0a.682.682,0,0,1,.681.681",
    transform: "translate(-177.995 -269.41)",
    fill: "#f36c87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M190.933,289.611a.682.682,0,1,1-.682-.681h0a.682.682,0,0,1,.681.681Z",
    transform: "translate(-177.995 -269.41)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M271.163,392.981a.682.682,0,1,1-.682-.681h0a.682.682,0,0,1,.681.681",
    transform: "translate(-253.327 -366.467)",
    fill: "#f36c87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M271.163,392.981a.682.682,0,1,1-.682-.681h0a.682.682,0,0,1,.681.681Z",
    transform: "translate(-253.327 -366.467)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M8.347,276.559a3.066,3.066,0,0,0-.5-.584,10.42,10.42,0,0,0-1.256-.84,4.192,4.192,0,0,0-2.075-.643,5.234,5.234,0,0,0-3.537,1.493,2.536,2.536,0,0,0-.493.618.742.742,0,0,0,.621,1.192,1.541,1.541,0,0,0,.667-.09c.653-.266,1.289-.568,1.934-.852.224-.1.455-.184.766-.308-.219.543-.153.737.248.984a1.432,1.432,0,0,0,.27.135,4.748,4.748,0,0,0,2.46.2,1.581,1.581,0,0,0,.834-.469.715.715,0,0,0,.057-.84",
    transform: "translate(-0.321 -255.852)",
    fill: "#fcb813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M7.3,333.409a4.335,4.335,0,0,0-2.817.218c-.5.22-.579.435-.438.994a2.342,2.342,0,0,1-.4-.1c-.229-.1-.44-.252-.672-.347a20.023,20.023,0,0,0-1.9-.723.769.769,0,0,0-1.069.6,1.435,1.435,0,0,0,.332.877A4.957,4.957,0,0,0,3.58,336.7a5.126,5.126,0,0,0,4.189-1.742.88.88,0,0,0-.465-1.549",
    transform: "translate(0 -311.042)",
    fill: "#fcb813"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2D);
export default __webpack_public_path__ + "static/media/2d.97626ca1106cd0bea79137246c88bc85.svg";
export { ForwardRef as ReactComponent };